import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { Breadcrumb, Space, Table, Button } from 'antd';
import Search from 'antd/lib/input/Search';
import { useDispatch, useSelector } from 'react-redux';
import AddSessionButton from './AddSessionButton';
import EditSessionsButton from './EditSessionsButton';
import DeleteSessionButton from './DeleteSessionButton';
import { getAllSessions } from '../../../redux/Session/actions';
import { getAllUsers } from '../../../redux/User/actions';


export const Session = () => {
  const dispatch = useDispatch();
  const sessions = useSelector((state) => state.sessions?.data || []);
  const users = useSelector((state) => state.Users?.data || []);
  const [filteredSessions, setFilteredSessions] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getAllSessions());
      await dispatch(getAllUsers());
      setLoading(false);
    };
    if (loading) {
      fetchData();
    }
  }, [dispatch, loading]);

  const handleSearch = (value) => {
    const filteredData = sessions.filter((session) =>
      session.sessionname.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredSessions(filteredData);
  };





  const columns = [
    {
      title: 'Session Name',
      dataIndex: 'sessionname',
      key: 'sessionname',
    },
    {
      title: 'Event',
      dataIndex: ['event', 'eventname'],
      key: 'eventname',
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (text) => new Date(text).toLocaleString(),
    },
    {
      title: 'Machine',
      dataIndex: ['machine', 'machinename'],
      key: 'machinename',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, item) => (
        <Space size="middle">
          <EditSessionsButton item={item} users={users} />
          <DeleteSessionButton item={item} />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>Sessions</Breadcrumb.Item>
      </Breadcrumb>

      <Grid container spacing={3} justify="space-between" alignItems="center">
        <Grid item>
          <Search
            placeholder="Search sessions"
            onSearch={handleSearch}
            style={{ width: 200 }}
          />
        </Grid>
        <Grid item>
          <AddSessionButton users={users} />
        </Grid>
      </Grid>

      <Table
        columns={columns}
        dataSource={filteredSessions.length ? filteredSessions : sessions}
        loading={loading}
        rowKey="_id"
      />


    </>
  );
};

export default Session;
